/* This file is auto-generated */

import type { ContractPromise } from '@polkadot/api-contract';
import type { KeyringPair } from '@polkadot/keyring/types';
import type { ApiPromise } from '@polkadot/api';
import type { GasLimit } from '@727-ventures/typechain-types';
import { txSignAndSend } from '@727-ventures/typechain-types';
import type * as ArgumentTypes from '../types-arguments/capsule';
import type BN from 'bn.js';
// eslint-disable-next-line
// @ts-ignore
import type { EventRecord } from '@polkadot/api/submittable';
import { decodeEvents } from '../shared/utils';
import EVENT_DATA_TYPE_DESCRIPTIONS from '../event-data/capsule.json';

export default class Methods {
	readonly __nativeContract: ContractPromise;
	readonly __keyringPair: KeyringPair;
	readonly __apiPromise: ApiPromise;

	constructor(apiPromise: ApiPromise, nativeContract: ContractPromise, keyringPair: KeyringPair) {
		this.__apiPromise = apiPromise;
		this.__nativeContract = nativeContract;
		this.__keyringPair = keyringPair;
	}

	/**
	 * mint
	 *
	 * @param { ArgumentTypes.AccountId } account,
	 * @param { (string | number | BN) } amount,
	 */
	mint(account: ArgumentTypes.AccountId, amount: string | number | BN, __options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'mint',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[account, amount],
			__options,
		);
	}

	/**
	 * burn
	 *
	 * @param { ArgumentTypes.AccountId } account,
	 * @param { (string | number | BN) } amount,
	 */
	burn(account: ArgumentTypes.AccountId, amount: string | number | BN, __options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'burn',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[account, amount],
			__options,
		);
	}

	/**
	 * holders
	 *
	 */
	holders(__options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'holders',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[],
			__options,
		);
	}

	/**
	 * transfer
	 *
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	 */
	transfer(
		to: ArgumentTypes.AccountId,
		value: string | number | BN,
		data: Array<number | string | BN>,
		__options?: GasLimit,
	) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'transfer',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[to, value, data],
			__options,
		);
	}

	/**
	 * transferFrom
	 *
	 * @param { ArgumentTypes.AccountId } from,
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	 */
	transferFrom(
		from: ArgumentTypes.AccountId,
		to: ArgumentTypes.AccountId,
		value: string | number | BN,
		data: Array<number | string | BN>,
		__options?: GasLimit,
	) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'transferFrom',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[from, to, value, data],
			__options,
		);
	}

	/**
	 * renounceOwnership
	 *
	 */
	renounceOwnership(__options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'ownable::renounceOwnership',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[],
			__options,
		);
	}

	/**
	 * owner
	 *
	 */
	owner(__options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'ownable::owner',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[],
			__options,
		);
	}

	/**
	 * transferOwnership
	 *
	 * @param { ArgumentTypes.AccountId | null } newOwner,
	 */
	transferOwnership(newOwner: ArgumentTypes.AccountId | null, __options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'ownable::transferOwnership',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[newOwner],
			__options,
		);
	}

	/**
	 * increaseAllowance
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } deltaValue,
	 */
	increaseAllowance(
		spender: ArgumentTypes.AccountId,
		deltaValue: string | number | BN,
		__options?: GasLimit,
	) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22::increaseAllowance',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[spender, deltaValue],
			__options,
		);
	}

	/**
	 * approve
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } value,
	 */
	approve(spender: ArgumentTypes.AccountId, value: string | number | BN, __options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22::approve',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[spender, value],
			__options,
		);
	}

	/**
	 * balanceOf
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 */
	balanceOf(owner: ArgumentTypes.AccountId, __options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22::balanceOf',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[owner],
			__options,
		);
	}

	/**
	 * allowance
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 * @param { ArgumentTypes.AccountId } spender,
	 */
	allowance(
		owner: ArgumentTypes.AccountId,
		spender: ArgumentTypes.AccountId,
		__options?: GasLimit,
	) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22::allowance',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[owner, spender],
			__options,
		);
	}

	/**
	 * allowances
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 */
	allowances(owner: ArgumentTypes.AccountId, __options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22::allowances',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[owner],
			__options,
		);
	}

	/**
	 * psp22::transfer
	 *
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	 */
	'psp22::transfer'(
		to: ArgumentTypes.AccountId,
		value: string | number | BN,
		data: Array<number | string | BN>,
		__options?: GasLimit,
	) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22::transfer',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[to, value, data],
			__options,
		);
	}

	/**
	 * psp22::transferFrom
	 *
	 * @param { ArgumentTypes.AccountId } from,
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	 */
	'psp22::transferFrom'(
		from: ArgumentTypes.AccountId,
		to: ArgumentTypes.AccountId,
		value: string | number | BN,
		data: Array<number | string | BN>,
		__options?: GasLimit,
	) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22::transferFrom',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[from, to, value, data],
			__options,
		);
	}

	/**
	 * decreaseAllowance
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } deltaValue,
	 */
	decreaseAllowance(
		spender: ArgumentTypes.AccountId,
		deltaValue: string | number | BN,
		__options?: GasLimit,
	) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22::decreaseAllowance',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[spender, deltaValue],
			__options,
		);
	}

	/**
	 * totalSupply
	 *
	 */
	totalSupply(__options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22::totalSupply',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[],
			__options,
		);
	}

	/**
	 * domainSeparator
	 *
	 */
	domainSeparator(__options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22Permit::domainSeparator',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[],
			__options,
		);
	}

	/**
	 * permit
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } value,
	 * @param { (number | string | BN) } deadline,
	 * @param { ArgumentTypes.Signature } signature,
	 */
	permit(
		owner: ArgumentTypes.AccountId,
		spender: ArgumentTypes.AccountId,
		value: string | number | BN,
		deadline: number | string | BN,
		signature: ArgumentTypes.Signature,
		__options?: GasLimit,
	) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22Permit::permit',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[owner, spender, value, deadline, signature],
			__options,
		);
	}

	/**
	 * tokenDecimals
	 *
	 */
	tokenDecimals(__options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22Metadata::tokenDecimals',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[],
			__options,
		);
	}

	/**
	 * contractType
	 *
	 */
	contractType(__options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22Metadata::contractType',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[],
			__options,
		);
	}

	/**
	 * tokenName
	 *
	 */
	tokenName(__options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22Metadata::tokenName',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[],
			__options,
		);
	}

	/**
	 * tokenSymbol
	 *
	 */
	tokenSymbol(__options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'psp22Metadata::tokenSymbol',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[],
			__options,
		);
	}

	/**
	 * nonces
	 *
	 * @param { ArgumentTypes.AccountId } account,
	 */
	nonces(account: ArgumentTypes.AccountId, __options?: GasLimit) {
		return txSignAndSend(
			this.__apiPromise,
			this.__nativeContract,
			this.__keyringPair,
			'nonces::nonces',
			(events: EventRecord) => {
				return decodeEvents(events, this.__nativeContract, EVENT_DATA_TYPE_DESCRIPTIONS);
			},
			[account],
			__options,
		);
	}
}
